import * as React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { newMobileClientCheck, setQuoteType } from '../../../actions/salesActions';
import { DASHBOARD, PERSONAL_INFO, GATHER_INFO } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import './Bling.css';
import { PRODUCT_BLING } from '../../../constants/constants';
import FAQItem from '../../FAQ/FAQItem';

class GetBlingInsurance extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleShowComingSoon = this.handleShowComingSoon.bind(this);
    }

    faqSet = [{
        question: "Why do I need to insure my cellphone?",
        answer: "<p class='mb-0px'>35% of people damage their cellphone within the first year. In fact, in a 2016 consumer survey, 50% of people admitted that they’d experienced a smartphone fiasco in the previous 2 years. 10% of these participants had 3 or 4 uh-oh moments, and an especially unlucky 9% had more than 5 incidents.<br/> <br/>So, the real question is: Why wouldn’t you insure your cellphone ?</p >",
        id: 1
    },
    {
        question: "What are the requirements for bling cellphone cover?",
        answer: "To get the king’s bling insurance, you need to:<ul class='nopa ml-15px mb-0px'><li>Be 18 years or older.</li><li>Have a South African ID number or international passport.</li></ul>",
        id: 2
    },
    {
        question: "What info do I need to submit to get bling cellphone cover?",
        answer: " Visit our app, follow the steps to get a quote and give us this info:<ul class='nopa ml-15px mb-0px'><li>Your personal details.</li><li>The make, model and value of the cellphone.</li><li>The phone’s IMEI and serial number.</li><li>Your banking details (for your debit order).</li></ul>",
        id: 3
    },
    {
        question: "What type of bling cellphone cover can I get from King Price?",
        answer: "When you insure your phone with the king of insurance, you get to choose from 3 cover options:<p class='mb-5px mt-10px font-weight-bold'>Like-new</p><p>King Price is the only insurer to offer like-new cover for phones. This cover not only comes with premiums that are 20% cheaper than the market average, but also ensures that your damaged phone’s repaired or replaced following theft, loss, accidental damage or water damage.    <br /><br />If we do replace your phone, it’ll be with a similar make and model or a similar, refurbished phone, and you’ll get a 12-month warranty!</p><p class='mb-5px mt-10px font-weight-bold'>Brand-new</p><p>The king’s brand-new cover ensures that your phone’s replaced with a brand-spanking-new phone following theft, loss, accidental damage or water damage.</p><p class='mb-5px mt-10px font-weight-bold'>Screen-fix</p><p class='mb-0px'>Screen-fix covers you for cracks to your phone’s screen due to accidental damage.",
        id: 4
    },
    {
        question: "Who underwrites the bling product?",
        answer: "We do. We’re an authorised FSP and we’ve got our very own underwriting team which evaluates each and every risk our kingdom covers.",
        id: 5
    },
    {
        question: "How do I get in touch with the bling team?",
        answer: "<ul class='nopa ml-15px mb-0px'><li>Via email <a target='_blank' href='mailto:bling@kingprice.co.za' class='text-red font-weight-bold text-decoration-underline'>bling@kingprice.co.za</a>.</li><li>Slide into our Facebook, Twitter or Instagram DMs <span class='text-red font-weight-bold text-decoration-underline'>@kingpriceinsurance</span>.</li></ul>",
        id: 6
    },
    {
        question: "What am I covered for?",
        answer: "<a target='_blank' href='https://www.kingprice.co.za/Content/documents/King-price-insurance-policy.pdf' class='text-red font-weight-bold text-decoration-underline'>Click here</a> to access our bling policy wording. Or, visit our website/app to see what the king’s bling insurance covers.",
        id: 7
    },
    {
        question: "Where am I covered?",
        answer: "You’re covered anywhere in the world.",
        id: 8
    },
    {
        question: "Will I be covered if my phone’s stolen while I’m away from home?",
        answer: "Yes, of course! You have places to go and people to meet. And, the majority of the time you take your cellphone with you. So, if you decided to take your phone with you on your morning run and anything goes pear-shaped… We’ll make sure you’re covered.",
        id: 9
    },
    {
        question: "What do I do if my phone’s been stolen?",
        answer: "If you’d like to claim for a stolen phone, you must first: <ul class='nopa ml-15px mb-0px'><li>Ask your service provider to blacklist your phone and get a reference number.</li><li>Report the theft to the police and get a SAPS case number. (The police will need your blacklist reference number for this.)</li><li>Give us your blacklist reference number and police case number.</li><li>Get a new SIM card. (We only take care of your phone’s repair/replacement.)</li></ul>",
        id: 10
    },
    {
        question: "How do I submit a bling cellphone insurance claim?",
        answer: "Via our app, website or by emailing us on <a target='_blank' href='mailto:blingdirectclaims@kingprice.co.za' class='text-red font-weight-bold text-decoration-unerdline'>blingdirectclaims@kingprice.co.za</a> . On both the app and website you’ll be asked to answer a few questions which will guide you through the claims process. In most cases we’re able to approve claims instantly (thanks to our super cool tech). However, in certain instances we’ll need to call you to get more info.",
        id: 11
    },
    {
        question: "How do I submit a claim if I’m overseas or traveling?",
        answer: "Because we’re app- and web-based, you can submit a claim from anywhere in the world. Simply log onto your app or our website and complete all the steps. You can report the incident at the airport or to the local police.",
        id: 12
    },
    {
        question: "Can my replacement phone be sent to a different address than the 1 on my policy info?",
        answer: "Of course! Once you’ve paid your excess via EFT to the supplier, you’ll be able to choose a delivery address anywhere in SA. Your new, like-new or repaired phone will then be delivered, pronto.",
        id: 13
    },
    {
        question: "Am I still covered if my phone’s been replaced?",
        answer: "<p class='mb-5px'>Yes, absolutely! If your phone’s damaged beyond repair, we’ll send you another 1 chop-chop and your cover will continue as usual.</p><p class='mb-0px'> If your phone’s lost/ stolen, and replaced, we automatically update your policy with the replacement phone for the replacement value.</p >",
        id: 14
    },
    {
        question: "I’d like to cancel my policy. Please help?",
        answer: "Pop us an email on <a target='_blank' href='mailto:clientcare@kingprice.co.za' class='text-red text-decoration-underline'>clientcare@kingprice.co.za</a> and we'll get right on it.",
        id: 15
    },
    {
        question: "I’m unhappy with my cover. Who can I speak to?",
        answer: "Email <a target='_blank' href='mailto:clientcare@kingprice.co.za' class='text-red font-weight-bold text-decoration-underline'>clientcare@kingprice.co.za</a> and we'll do our best to turn your frown into a smile!",
        id: 16
    },

    ]

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleShowComingSoon() {
        this.props.dispatchShowOopsPortablePossessionError();
    }

    async handleRedirect() {
        var nextPage = GATHER_INFO;
        if (this.props.profile.policyId !== "") {
            nextPage = GATHER_INFO;
            await this.props.dispatchSetQuoteType();
        }
        await this.props.dispatchSetQuoteType();
        await this.props.dispatchCreditHistoryCheck();
        this.props.redirectTo(nextPage);
    }

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        let faq;
        if (this.faqSet) {
            faq = this.faqSet.map((item) => {
                if (item.question !== "") {
                    return <FAQItem className="mb-12px" header={item.question} body={item.answer} keyId={item.id} />
                }
            });
        }
        return (
            <div id="GetPortable" >
                <div className={this.state.loggedIn ? "container-fluid new-page-margins" : "logged-out"}>
                    <div className="new-breadcrumbwrapper breadcrumb-wrapper-claims-actual">
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Get bling cellphone insurance" />
                    </div>
                    <div className="new-page-main-row justify-content-center">
                        <Card id="GetBlingInsuranceBanner" className="content-box-padding-20px-with-box-shadow">
                            <div className="row noma">
                                <div className="nopa">
                                    <div className="mb-20px text-lg-left text-md-left text-center bling-image-holder">
                                        <img src="./Images/Bling/icon-bling-small.png" alt="" title="" className="img-fluid bling-img-width" />
                                    </div>
                                    <h2 className="Bling-cellphone-title mb-10px">Bling cellphone insurance</h2>
                                    <p className="font-weight-normal mb-25px bling-info">Bling cellphones are covered as specified portable possessions, which means that your bling cover is worldwide. So wherever you and your phone are in the world, we're right there with you. Even if it's just at the local KFC or your ouma's house. The only thing you need to worry about is making sure you choose the correct replacement value.</p>
                                    <div className="text-center text-md-left text-lg-left get-bling-quote">
                                        <button className="btn btn-solid-green" onClick={this.handleRedirect}>Get a quote</button>
                                    </div>
                                </div>
                                <div className="border-right border-bottom"></div>
                                <div className="col nopa mt-auto mb-auto">
                                    <p className="font-size-22px line-height-normal mb-20px"><b>You have 3 cover options to choose from</b></p>
                                    <ul className="bling-cover-options">
                                        <li className="font-weight-normal">Brand-new</li>
                                        <li className="font-weight-normal">Like-new</li>
                                        <li className="font-weight-normal">Screen-fix</li>
                                    </ul>
                                </div>
                            </div>
                        </Card>
                        <div className="row noma bling-faqs-block">
                            <div className="col-12 col-lg nopa mr-10px mobile-mr-0px mobile-mb-20px">
                                <Card className="content-box-padding-20px-with-box-shadow mb-15px">
                                    <div className="mb-20px">
                                        <p className="font-size-22px font-weight-bold text-red mb-0px">You’re only covered if</p>
                                    </div>
                                    <div className="row noma mb-15px">
                                        <div className="mr-20px">
                                            <img alt="" title="" src="./Images/Bling/Bling IMEI icon 01 1.svg" />
                                        </div>
                                        <div className="col nopa description-holder">
                                            <p className="mb-0px font-size-12px font-weight-normal line-height-normal covered-description-p">The <b>IMEI number</b> of the phone that you're claiming for, matches the IMEI number on your policy schedule.</p>
                                        </div>
                                    </div>
                                    <div className="row noma">
                                        <div className="mr-20px">
                                            <img alt="" title="" src="./Images/Bling/IMEI icon 02.svg"/>
                                        </div>
                                        <div className="col nopa description-holder">
                                            <p className="mb-0px font-size-12px font-weight-normal line-height-normal covered-description-p">The phone with the IMEI number on your policy schedule has been <b>used for calls or SMSs</b>, using the phone number (SIM card) on your policy schedule.</p>
                                        </div>
                                    </div>
                                </Card>
                                <Card className="content-box-padding-20px-with-box-shadow ">
                                    <div className="row noma">
                                        <div className="mr-20px">
                                            <img alt="" title="" src="./Images/Bling/bling-brand-new.svg"/>
                                        </div>
                                        <div className="col nopa">
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-7px">Brand-new</p>
                                            <p className="mb-0px font-size-12px font-weight-normal line-height-normal covered-description-p">Brand-new cover means we’ll repair your damaged phone if we can or replace it with a brand-spanking-new phone if we need to, following theft, loss, accidental damage or water damage.</p>
                                        </div>
                                    </div>
                                    <hr className="get-bling-hr-2px" />
                                    <div className="row noma">
                                        <div className="mr-20px">
                                            <img alt="" title="" src="./Images/Bling/Bling-like-new.svg" />
                                        </div>
                                        <div className="col nopa">
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-7px">Like-new</p>
                                            <p className="mb-0px font-size-12px font-weight-normal line-height-normal covered-description-p">Like-new cover means we’ll repair your damaged phone if we can, or replace it if we need to, following theft, loss, accidental damage or water damage. Replacement will be with a similar make and model or a similar, refurbished phone.</p>
                                        </div>
                                    </div>
                                    <hr className="get-bling-hr-2px" />
                                    <div className="row noma">
                                        <div className="mr-20px">
                                            <img alt="" title="" src="./Images/Bling/Bling-screen-fix.svg" />
                                        </div>
                                        <div className="col nopa">
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-7px">Screen-fix</p>
                                            <p className="mb-0px font-size-12px font-weight-normal line-height-normal covered-description-p">Screen-fix cover is only for cracks to your phone’s screen due to accidental damage.</p>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="col-12 col-lg nopa ml-5px mobile-ml-0px">
                                <Card className="content-box-padding-20px-with-box-shadow bling-what-to-do-holder">
                                    <div className="font-size-22px text-red font-weight-bold mb-20px">FAQs</div>
                                    <div className="new-ssp-bling-faq-block bling-what-to-do-accordion-holder">
                                        <Accordion>
                                            {faq}
                                        </Accordion>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchCreditHistoryCheck: () => dispatch(newMobileClientCheck("", true, null)),
        dispatchSetQuoteType: () => dispatch(setQuoteType(PRODUCT_BLING)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetBlingInsurance);